/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Child } from './Child';
import {
    ChildFromJSON,
    ChildFromJSONTyped,
    ChildToJSON,
} from './Child';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface ChildPagination
 */
export interface ChildPagination {
    /**
     * 
     * @type {Array<Child>}
     * @memberof ChildPagination
     */
    data?: Array<Child>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof ChildPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the ChildPagination interface.
 */
export function instanceOfChildPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChildPaginationFromJSON(json: any): ChildPagination {
    return ChildPaginationFromJSONTyped(json, false);
}

export function ChildPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChildPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(ChildFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function ChildPaginationToJSON(value?: ChildPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ChildToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

